import { render, staticRenderFns } from "./MySidebarChildren.vue?vue&type=template&id=e8bf22f8"
import script from "./MySidebarChildren.vue?vue&type=script&lang=js"
export * from "./MySidebarChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports